import { gql } from '__generated__';

export default gql(`
  query GetSettlementsReport($project: ID!) {
    project(id: $project) {
      id
      settlements {
        id
        reference
        amount
        settled_at
      }
    }
  }
`);
